import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
const { PROCEDURE_15 } = environment;
@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }

  getTitleCardsD(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Dashboard`);
  }

  getAmount(): Observable<any> {
    return this.http.get(`${PROCEDURE_15}/Dashboard/GetByStatus`);
  }
}
